import * as types from '../mutation-types'
import { api } from '@/modules/api/index'

export const state = {
  list: {}
}

export const getters = {
  blackList: state => state.list
}

export const actions = {
  async getBlackList ({ commit }) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios.get(api.blackList.get())
      commit(types.SET_BLACK_LIST, data)
      return data
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Black list weren\'t fetched')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async addTagToBlacklist ({ commit }, tag) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const response = await this.$axios.post(api.blackList.addToBlacklist(tag))
      commit(types.CREATE_SUCCESS_MESSAGE, 'Tag added to blacklist successfully')
      return response
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Tag wasn\'t added')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async deleteFromBlacklist ({ commit }, id) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const response = await this.$axios(
        { method: 'delete', url: api.blackList.deleteFromBlacklist(id) })
      commit(types.CREATE_SUCCESS_MESSAGE, 'Tag was deleted from blacklist successfully')
      return response
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Tag wasn\'t deleted')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  }
}

export const mutations = {
  [types.SET_BLACK_LIST] (state, { blacklistTags }) {
    state.list = [...blacklistTags]
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/blackList.js